<template>
  <div v-if="raisonnement == null || !ifRaisonnementFinished" class="test-section">
    <div class="test-section-content">
      <div>
        <div class="test-circle"/>
      </div>
      <div class="test-section-content-label">
        Expression
        <span class="test-section-content-label-time">({{ duration }} min)</span>
      </div>
    </div>
  </div>

  <div v-else-if="expression == null" class="test-section">
    <div class="test-section-content">
      <div>
        <div class="test-circle test-circle--active"/>
      </div>
      <div class="test-section-content-label">
        <router-link :to="toCommencer">
          Expression
        </router-link>
        <span v-if="!thirdTime" class="test-section-content-label-time">({{ duration }} min)</span>
        <span v-else class="test-section-content-label-time">
          ({{ duration }} min : vous bénéficiez du tiers-temps)
        </span>
      </div>
    </div>
  </div>

  <div v-else-if="!ifExpressionFinished" class="test-section">
    <div class="test-section-content test-section-content--active">
      <div>
        <div class="test-circle test-circle--active"/>
      </div>
      <div class="test-section-content-label">
        <router-link :to="toQuestion">
          Expression
        </router-link>
        <span class="test-section-content-label-time">
          <span id="countDownExpression"></span>
          <img alt="clock" class="test-section-content-label-clock" src="@/assets/img/animated-clock.gif">
        </span>
      </div>
    </div>
  </div>

  <div v-else class="test-section test-section--active">
    <div class="test-section-content">
      <div class="test-icon">
        <img alt="completed" src="@/assets/img/check.png">
      </div>
      <div class="test-section-content-label">Expression</div>
    </div>
  </div>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from 'vue'
import TestApi from '@/api/TestApi'
import RouteEnum from "@/router/RouteEnum";

const toQuestion =  { name: RouteEnum.TEST_QUESTION, params: { type: 'expression' }}
const toCommencer = { name: RouteEnum.TEST_COMMENCER, params: { type: 'expression' }}

// Props
const props = defineProps({
  raisonnement: {
    type: Object,
    default: null
  },
  expression: {
    type: Object,
    default: null
  },
  ifIntroductionFinished: Boolean,
  ifArgumentationFinished: Boolean,
  ifRaisonnementFinished: Boolean,
  ifExpressionFinished: Boolean,
  ifCalculsFinished: Boolean
})

// Reactive state
const thirdTime = ref(false)
const limitTest = ref(false)
const limitTestText = ref(localStorage.getItem('textLimitTest') || null)
const duration = ref(0)
const initialDuration = ref(0)
const counter = ref(0)

let countDownExpression = null
let intervalFinishTests = null

// Load thirdTime from localStorage
try {
  const stored = localStorage.getItem('thirdTime')
  thirdTime.value = stored ? JSON.parse(stored) : false
} catch (e) {
  thirdTime.value = false
}

// Countdown logic
const intervalAction = () => {
  const countdownEl = document.getElementById('countDownExpression')
  if (!countdownEl || !expression?.remainingTime) {
    clearInterval(countDownExpression)
    return
  }

  counter.value += 1
  const remaining = expression.remainingTime - counter.value

  if (remaining <= 0) {
    countdownEl.innerHTML = '(Temps écoulé)'
  } else {
    let seconds = Math.floor(remaining)
    let minutes = Math.floor(seconds / 60)
    let heures = Math.floor(minutes / 60)

    heures %= 24
    minutes %= 60
    seconds %= 60

    minutes = String(minutes).padStart(2, '0')
    seconds = String(seconds).padStart(2, '0')

    const totalMinutesExpression = heures * 60 + Number(minutes)
    localStorage.setItem('totalMinutesExpression', JSON.stringify(totalMinutesExpression))

    if (!limitTest.value) {
      countdownEl.innerHTML = `${heures}:${minutes}:${seconds}`
    }
  }
}

const displayLimitTest = () => {
  const timestampLimitTest = JSON.parse(localStorage.getItem('limitTest'))
  const totalMinutesExpression = JSON.parse(localStorage.getItem('totalMinutesExpression'))

  if (!timestampLimitTest || totalMinutesExpression == null) return

  const currentTimestamp = Math.floor(Date.now() / 1000)
  const differenceInMinutes = Math.floor((timestampLimitTest - currentTimestamp) / 60)

  if (differenceInMinutes < totalMinutesExpression) {
    limitTest.value = true
    const countdownEl = document.getElementById('countDownExpression')
    if (countdownEl && differenceInMinutes !== null) {
      countdownEl.innerHTML = `Il ne reste plus que <strong>${differenceInMinutes}</strong> minutes !`
    }
  }
}

const startCountDown = () => {
  countDownExpression = setInterval(intervalAction, 1000)
  intervalFinishTests = setInterval(displayLimitTest, 1000)
}

// Fetch duration and start countdown
onMounted(async () => {
  try {
    const response = await TestApi.getTestQuestionDomainById(1) // Domain ID for Expression
    initialDuration.value = duration.value = response.data.duration

    if (thirdTime.value) {
      duration.value = Math.ceil(duration.value * 1.33)
    }
  } catch (error) {
    console.error('Failed to fetch duration for Expression', error)
  }

  startCountDown()
})

onBeforeUnmount(() => {
  if (countDownExpression) clearInterval(countDownExpression)
  if (intervalFinishTests) clearInterval(intervalFinishTests)
})
</script>
